<template>
  <div>
    <h2>{{asset.title}}</h2>
  </div>
</template>

<script>
export default {
  props: ["asset"]
};
</script>

<style>
</style>